angular.module('impactx.scheduler').controller('SchedulerCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'ConfirmationService',
    'ToastService',
    'TranslationService',
    '$redirect',
    'BackService',
    'ToolbarService',
    SchedulerCtrl]);

function SchedulerCtrl($scope, dataGen, $routeParams, ConfirmationService, ToastService, TranslationService, $redirect, BackService, ToolbarService) {
    var self = this;
    var initialSCHId = $routeParams.id;
    $scope.isRetrievingActiveTask = false;
    $scope.frequencyCardOpened = false;
    self.isRetrievingActiveTask = true;

    self.sortableOptions = {
        start: function (event, ui) {
            ui.item.data('start_pos', ui.item.index());
        },
        stop: function (event, ui) {
            var start_pos = ui.item.data('start_pos');
            if (start_pos !== ui.item.index() && !$scope.hasInvalidTask()) {
                self.reorderTasks();
            }
            self.setSelectedTask($scope.data.tasks[ui.item.index()]);
        }
    };

    self.getDialogData = function (schId) {
        self.isRetrievingActiveTask = true;
        dataGen.getData($scope, {schId: schId}, '/scheduler/view').then(function (response) {
            self.isRetrievingActiveTask = false;
            if (impactX.isDefined(response, "data.tasks") && schId == 0) {
                self.setSelectedTask($scope.data.tasks[0]);
            }
            else {
                angular.forEach($scope.data.tasks, function (task) {
                    if (task.id == schId) {
                        self.setSelectedTask(task);
                        return;
                    }
                });
            }

            defineButtons();
        });
    };

    self.getDialogData(initialSCHId);

    self.setSelectedTask = function (task) {
        angular.forEach($scope.data.tasks, function (entry) {
            entry.selected = false;
        });
        task.selected = true;
        $scope.selectedTaskIndex = -1;
        $scope.selectedTaskIndex = $scope.data.tasks.indexOf(task);

        if ($scope.selectedTaskIndex < 0) {
            $scope.selectedTaskIndex = 0;
        }
    };

    self.reorderTasks = function () {
        dataGen.postAsForm($scope, {tasks: $scope.data.tasks}, '/scheduler/reorder').then(function () {
            ToastService.openStandardToast($scope.trns.reorderSuccess);
        });

    };

    self.addNewTask = function () {
        var copy = angular.copy($scope.data.tasks[$scope.selectedTaskIndex]);
        copy.id = 0;
        copy.description.value = "";
        copy.responseTime.value = 0;
        copy.debugMode = {value: false};
        copy.taskSuccessMessage.value = false;
        copy.taskSelection = $scope.data.taskSelection.entries[0];
        copy.chainIdentifier = $scope.data.tasks[0].id > 0 ? $scope.data.tasks[0].id.toString() : undefined;
        copy.chainposition = $scope.data.tasks.length - 1;
        delete copy.parameters;

        $scope.data.tasks.push(copy);
        self.setSelectedTask(copy);
        $scope.schedulerTaskCtrl.getTaskData(copy.taskSelection.id, false).then(function (newTaskData) {
            if (newTaskData) {
                newTaskData.chainIdentifier = $scope.data.tasks[0].id.toString();
            }
            ToastService.openStandardToast($scope.trns.newTaskAdded || TranslationService.get('newTaskAdded'));
        });
    };

    self.deleteTask = function (event, task, hideConfirmation) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        if (hideConfirmation) {
            self.deleteTaskRequest(task);
        }
        else {
            ConfirmationService.showConfirmationDialog(function () {
                self.deleteTaskRequest(task)
            }, event, $scope.trns.deleteTask, $scope.trns.save, $scope.trns.abort, $scope.trns.deleteTaskQuestion);
        }
    };

    self.deleteTaskRequest = function (task) {
        if (task.id > 0) {
            dataGen.postAsForm($scope, {task: task}, '/scheduler/delete').then(function () {
                removeTaskFromList(task);
            });
        }
        else {
            removeTaskFromList(task);
        }
    };

    self.deleteTaskChain = function (event) {
        var task = $scope.data.tasks[0];
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        ConfirmationService.showConfirmationDialog(function () {
            self.deleteTaskChainRequest(task);
        }, event, $scope.trns.deleteTaskChain, $scope.trns.delete, $scope.trns.abort, $scope.trns.deleteTaskChainQuestion);
    };

    self.deleteTaskChainRequest = function (task) {
        dataGen.postAsForm($scope, {task: task}, '/scheduler/delete/chain').then(function () {
            ToastService.openStandardToast($scope.trns.deleteTaskChainSuccess);
            $redirect.redirectTo(null, "/schedulerlist");
        });
    };

    self.runTask = function () {
        var task = $scope.data.tasks[0];
        if (!task.invalid) {
            saveTaskChainRequest().then(function () {
                runTaskRequest(task.id).then(function () {
                    ToastService.openStandardToast($scope.trns.runTaskSuccess.replace('^0', impactX.isDefined(task, 'taskSelection.value')));
                });
            });
        }
    };

    self.saveTask = function (selectedTask) {
        saveTaskRequest($scope, selectedTask).then(function (response) {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            self.getDialogData(impactX.isDefined(response, 'data.id'));
        });
    };

    self.saveTaskChain = function () {
        saveTaskChainRequest().then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            BackService.back();
        });
    };

    function saveTaskChainRequest() {
        var requestObject = {
            taskChainData: {
                frequency: $scope.data.frequency,
                tasks: $scope.data.tasks
            }
        };
        return dataGen.postAsForm({}, requestObject, '/scheduler/save/chain');
    }

    self.saveFrequency = function () {
        dataGen.postAsForm($scope, {
            frequency: $scope.data.frequency,
            taskId: $scope.data.tasks[0].id
        }, '/scheduler/frequency/save').then(function () {
            ToastService.openStandardToast($scope.trns.saveSuccess);
        });
    };

    self.toggleFrequencyCard = function () {
        $scope.frequencyCardOpened = !$scope.frequencyCardOpened;
    };

    $scope.hasInvalidTask = function () {
        if ($scope.data && $scope.data.tasks) {
            return $scope.invalidTask || $scope.data.tasks.filter(function (task) {
                return task.invalid;
            }).length > 0;
        }
        else {
            return false;
        }
    };

    function removeTaskFromList(task) {
        $scope.$applyAsync(function () {
            var originalSelected = $scope.data.tasks[$scope.selectedTaskIndex];
            var index = $scope.data.tasks.indexOf(task);
            $scope.data.tasks.splice(index, 1);
            if (task.id === originalSelected.id) {
                self.setSelectedTask($scope.data.tasks[$scope.data.tasks.length - 1]);
            }
        });

        ToastService.openStandardToast($scope.trns.deleteSuccess.replace('^0', task.taskSelection.value));
    }

    function runTaskRequest(taskId) {
        return dataGen.postAsForm($scope, {taskId: taskId}, '/scheduler/task/run');
    }

    function saveTaskRequest(destinationObject, task, previousTask) {
        var requestObject = {
            taskData: task,
            previousTaskId: previousTask ? previousTask.id : undefined
        };
        return dataGen.postAsForm(destinationObject, requestObject, '/scheduler/task/save');
    }

    function defineButtons() {
        var buttonDefinition = [
            // Disabled "save" and "run" until dialog works
            // {
            //     label: $scope.trns.saveTaskChain,
            //     action: self.saveTaskChain,
            //     type: 'validation',
            //     params: {
            //         form: $scope.dialogData,
            //         disableExpression: {valueFunction: disableSave, error: $scope.trns.notConfiguredTasksHint}
            //     }
            // },
            // {
            //     labelFunction: getRunLabel,
            //     action: self.runTask,
            //     type: 'validation',
            //     condition: canRunTask,
            //     params: {
            //         form: $scope.dialogData
            //     }
            // },
            {
                label: $scope.trns.deleteTaskChain,
                action: self.deleteTaskChain,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function disableSave() {
        return $scope.hasInvalidTask();
    }

    function getRunLabel() {
        return $scope.data.tasks.length > 1 ? $scope.trns.runTaskChain : $scope.trns.runTask;
    }

    function canRunTask() {
        return $scope.data.tasks.length > 0 && initialSCHId > 0;
    }

    function canDelete() {
        return $scope.data.tasks.length > 0  && initialSCHId > 0;
    }
}